import { featureAbbr } from "../../configs/constants";
const messages = {
  [`${featureAbbr}.count`]: "بعضی از آیتم های فاکتور موجود نیستند",

  "auth.notif.new": "افزودن کاربر جدید",
  "auth.section.new": "افزودن بخش جدید",
  "auth.access.manage": "مدیریت دسترسی ها",

  "notif.info.NotifBaseTypeId": "دسته بندی",
  "notif.info.Date": "تاریخ",
  "notif.info.CreateDate": "تاریخ ایجاد",
  "notif.info.Time": "ساعت",
  "notif.info.Title": "عنوان",
  "notif.info.BodyText": "متن اعلان",
  "notif.info.NotifTargetType": "دسته بندی مقصد",
  "notif.info.TargetIds": "شناسه مقصد",
  "notif.info.IsSeen": "وضعیت مشاهده",
  "notif.info.search": "مشاهده اعلانها",
  "notif.info.new": "اعلان جدید",

  "notif.info.cancel": "انصراف",
  "notif.info.save": "ثبت اعلان",

  "role.info.title": "نام گروه",
  "role.info.save": "ثبت گروه",
  "role.info.isActive": "فعال",

  "permission.form.save": "ثبت دسترسی فرم",
  "permission.element.save": "ثبت دسترسی اجزای فرم",
  "permission.notif.remove": "حذف دسترسی اختصاصی کاربر",
};

export default messages;
